import { RateModes } from "../../../../lib/const/rateModes";
import { RateTypes } from "../../../../lib/const/rateTypes";
import { DictionaryDto } from "../../../../lib/interfaces";

export const getAllowedRateTypes = (rateType: DictionaryDto<RateTypes>[], rateModeId?: RateModes) =>
  rateType.filter(({ id }) => {
    switch (rateModeId) {
      case RateModes.ONE_TIME:
        return id === RateTypes.FIXED_PRICE;
      case RateModes.PERIODIC:
        return id === RateTypes.PREPAYMENT_VOLUME;
      case RateModes.TRAFFIC:
        return [RateTypes.FIXED_PRICE, RateTypes.UNIT_VOLUME, RateTypes.RANGE_VOLUME].includes(id);
      default:
        return true;
    }
  });
